"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const prop_types_1 = __importDefault(require("prop-types"));
const useModalState_1 = __importDefault(require("../../../hooks/useModalState"));
const copy_move_resource_modal_1 = __importDefault(require("../../modal/copyMoveResourceModal/copy-move-resource-modal"));
const notify_1 = require("../../notify/notify");
const entityTypes = {
    campaign: 'campaign',
    successplay: 'successplay',
    experience: 'experience',
};
const getEntityDisplayName = (type) => {
    if (type === entityTypes.experience) {
        return 'Experience';
    }
    if (type === entityTypes.campaign) {
        return 'Campaign';
    }
    return 'Success Play';
};
const CopyModalUiWrapper = ({ sbId, usedNames, entityToCopy, isBulkAction, onCloseModal, onCopyComplete, onHandleCancel, bulkEntitiesToCopy, currentTeamId, updateCampaigns, updateSuccessPlays, setCopyEntityAction, getAllLabelsWithResourcesAction, fetchRestrictedNamesAction, copyEntityAction, copyBulkEntitiesAction, setCopyBulkEntitiesAction, extraValidation, extraPropsForModal, }) => {
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    const { closeModal, openModal, isOpen, } = (0, useModalState_1.default)(true);
    const title = (0, react_1.useMemo)(() => {
        const entityType = getEntityDisplayName(entityToCopy?.entity_type);
        return `Copy ${isBulkAction ? 'Multiple Cards' : entityType}`;
    }, [entityToCopy, isBulkAction]);
    const type = (0, react_1.useMemo)(() => (isBulkAction ? 'bulk' : (entityTypes[entityToCopy?.entity_type] || entityTypes.successplay)), [isBulkAction, entityToCopy]);
    const handleCancel = (0, react_1.useCallback)(() => {
        closeModal();
        onCloseModal();
        onHandleCancel();
    }, [closeModal, onCloseModal, onHandleCancel]);
    const handleCopy = (0, react_1.useCallback)(async (data) => {
        closeModal();
        onCloseModal();
        setIsSaving(true);
        const copyData = {
            entity_name: data.name,
            entity_type: type,
            entity_id: entityToCopy.entity_id,
            sb_id: data.sbId,
            labels: data.labels,
            folder_id: data.selectedFolderId || -1,
            track_id: data.selectedTrack.id,
            track_position: data.newPositionInTrack.key,
        };
        try {
            const copyResult = await copyEntityAction(copyData);
            setCopyEntityAction(null);
            // update redux with new entity
            const { full_entity: fullEntity, track_id: trackId, track_position: trackPosition } = copyResult || {};
            if (onCopyComplete) {
                onCopyComplete({ sbId: data.sbId, folderId: data.selectedFolderId, trackId, fullEntity, trackPosition });
            }
            // update info that item in folder has been created
            if (type === entityTypes.campaign) {
                const { entity_id: newCampaignId } = copyResult;
                updateCampaigns(newCampaignId);
            }
            else if (type === entityTypes.successplay) {
                updateSuccessPlays();
            }
            if (data.labels.length) {
                getAllLabelsWithResourcesAction({ team_id: currentTeamId });
            }
            (0, notify_1.renderNotify)({
                class_name: 'success',
                title: `${getEntityDisplayName(type)} has been successfully copied`,
            });
        }
        catch (err) {
            console.error('Error while copying entity', err, copyData);
            (0, notify_1.renderNotify)({
                class_name: 'error',
                title: `${getEntityDisplayName(type)} copy failed`,
                text: 'Failed to copy entity to the other location',
            });
        }
    }, [closeModal, onCloseModal, setIsSaving, type, entityToCopy.entity_id, copyEntityAction, setCopyEntityAction, onCopyComplete, updateCampaigns, updateSuccessPlays, getAllLabelsWithResourcesAction, currentTeamId]);
    const validateModalForm = (0, react_1.useCallback)((data) => {
        const { name, location, hasConflictTerms, sb } = data;
        const validations = {};
        if (!name) {
            validations.name = true;
            validations.error = 'Name is required';
        }
        else if (usedNames instanceof Set && usedNames.has(name)) {
            validations.name = true;
            validations.error = 'Name is already in use';
        }
        else if (location ? location.key === 'sb' : (!hasConflictTerms || (hasConflictTerms && !sb))) {
            validations.error = 'Location is required';
        }
        if (!validations.error) {
            return extraValidation(data);
        }
        return validations;
    }, [usedNames, extraValidation]);
    const handleBulkCopy = (0, react_1.useCallback)(async (data) => {
        closeModal();
        onCloseModal();
        setIsSaving(true);
        try {
            const copyResult = await copyBulkEntitiesAction(data);
            setCopyBulkEntitiesAction(null);
            const isSameSb = data[0].sb_id === sbId;
            if (isSameSb && onCopyComplete) {
                copyResult.value.forEach((copiedEntity) => {
                    const { full_entity: fullEntity, track_id: trackId, track_position: trackPosition } = copiedEntity || {};
                    onCopyComplete({ sbId: data.sbId, folderId: data.selectedFolderId, trackId, fullEntity, trackPosition });
                });
                if (data.some((dataItem) => dataItem.labels.length)) {
                    getAllLabelsWithResourcesAction({ team_id: currentTeamId });
                }
            }
            (0, notify_1.renderNotify)({
                class_name: 'success',
                title: 'Entities has been successfully copied',
            });
        }
        catch (err) {
            (0, notify_1.renderNotify)({
                class_name: 'error',
                title: 'Entities copy failed',
                text: 'Failed to copy entities to the other location',
            });
        }
    }, [closeModal, copyBulkEntitiesAction, currentTeamId, getAllLabelsWithResourcesAction, onCloseModal, onCopyComplete, sbId, setCopyBulkEntitiesAction, setIsSaving]);
    (0, react_1.useEffect)(() => {
        if ((entityToCopy || isBulkAction) && !isOpen && !isSaving) {
            openModal();
            fetchRestrictedNamesAction(sbId, type);
        }
    }, [entityToCopy, isBulkAction, isOpen, isSaving, openModal, sbId, type, fetchRestrictedNamesAction]);
    if (!entityToCopy && !isBulkAction) {
        return null;
    }
    return isOpen && (react_1.default.createElement(copy_move_resource_modal_1.default, { isOpen: isOpen, currentFolderLocationId: "1", currentSbLocationId: sbId, title: title, action: "Copy", closeModal: handleCancel, item: entityToCopy, bulkItems: bulkEntitiesToCopy, resourceType: type, onSubmitCallback: handleCopy, onBulkSubmitCallback: handleBulkCopy, validateModalForm: validateModalForm, showDescription: false, usedNames: usedNames, shouldDisableFolderButtonForGlobal: true, ...extraPropsForModal }));
};
CopyModalUiWrapper.defaultProps = {
    sbId: 0,
    usedNames: [],
    entityToCopy: {},
    isBulkAction: false,
    onCloseModal: lodash_1.noop,
    onCopyComplete: lodash_1.noop,
    onHandleCancel: lodash_1.noop,
    bulkEntitiesToCopy: [],
    currentTeamId: '',
    updateCampaigns: lodash_1.noop,
    updateSuccessPlays: lodash_1.noop,
    setIsSaving: lodash_1.noop,
    isSaving: false,
    setCopyEntityAction: lodash_1.noop,
    getAllLabelsWithResourcesAction: lodash_1.noop,
    fetchRestrictedNamesAction: lodash_1.noop,
    copyEntityAction: lodash_1.noop,
    copyBulkEntitiesAction: lodash_1.noop,
    setCopyBulkEntitiesAction: lodash_1.noop,
    extraValidation: lodash_1.noop,
    extraPropsForModal: {},
};
CopyModalUiWrapper.propTypes = {
    sbId: prop_types_1.default.number,
    usedNames: prop_types_1.default.instanceOf(Set),
    entityToCopy: prop_types_1.default.object,
    isBulkAction: prop_types_1.default.bool,
    onCloseModal: prop_types_1.default.func,
    onCopyComplete: prop_types_1.default.func,
    onHandleCancel: prop_types_1.default.func,
    bulkEntitiesToCopy: prop_types_1.default.array,
    currentTeamId: prop_types_1.default.string,
    updateCampaigns: prop_types_1.default.func,
    updateSuccessPlays: prop_types_1.default.func,
    setIsSaving: prop_types_1.default.func,
    isSaving: prop_types_1.default.bool,
    setCopyEntityAction: prop_types_1.default.func,
    getAllLabelsWithResourcesAction: prop_types_1.default.func,
    fetchRestrictedNamesAction: prop_types_1.default.func,
    copyEntityAction: prop_types_1.default.func,
    copyBulkEntitiesAction: prop_types_1.default.func,
    setCopyBulkEntitiesAction: prop_types_1.default.func,
    extraValidation: prop_types_1.default.func,
    extraPropsForModal: prop_types_1.default.object,
};
exports.default = CopyModalUiWrapper;
//# sourceMappingURL=copyModal.js.map